/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, take, put, call, select, takeEvery,
} from 'redux-saga/effects';
import { END } from 'redux-saga';
import mbpLogger from 'mbp-logger';

import memberDucks from '../../../../Member/ducks';
import * as actions from './DTW-Actions';
import * as actionTypes from './DTW-ActionTypes';

import { getOrderId, getDTWOptions } from '../../../../Common/Common-Selectors';
import { mfeGetCart } from '../../Cart/Cart-Actions';
import { updateShowLoadingMessage, flagOffShowLoadingMessage } from '../../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';
import { prepareRetreiveCart } from '../../Cart/ducks/RetrieveCart/PrepareRetreiveCart-Operations';
import { processFeatureErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import { clearOrderItemErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Actions';

const {
    auth: {
        // authActions,
        authOperations,
    },
} = memberDucks;

const { checkJWT } = authOperations.workers;

function* workerGetDeliveryTime(action) {
    try {
        const { data } = action.data;
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);

        if (cartId) {
            clearOrderItemErrors(
                data.orderItemId,
                'dtw',
                { errType: '', field: 'error' },
            );

            const payload = {
                jwtToken,
                cartItemId: data.orderItemId,
                deliveryDate: data.deliveryDate,
                cartId,
            };

            const getDTWResponse = yield call(cartServiceClient.getDeliveryTime, payload);

            if (
                getDTWResponse
                && getDTWResponse.data
                && getDTWResponse.data.options
                && getDTWResponse.data.options.length > 0
            ) {
                const standardDelivery = getDTWResponse.data.options[getDTWResponse.data.options.length - 1];
                getDTWResponse.data.options.pop();
                getDTWResponse.data.options.splice(0, 0, standardDelivery);
            }

            yield put(actions.updateDTWOptions(getDTWResponse.data));
        }
    } catch (ex) {
        const windowLocation = (typeof window !== 'undefined') ? window.location.href : '';
        if (ex.response?.data.errorKey !== 'ERROR_DTW_RESPONSE_INVALID') {
            mbpLogger.logError({
                data: action.data,
                appName: process.env.npm_package_name,
                module: 'DTW-Operations.js',
                function: 'workerGetDeliveryTime',
                jsError: ex,
                message: 'workerGetDeliveryTime',
                windowLocation,
            });
        }

        yield put(actions.updateDTWOptions({
            cartItemId: action.data.data.orderItemId,
            dtwOptions: [],
        }));

        if (ex.response?.data.errorKey !== 'ERROR_DTW_RESPONSE_INVALID') {
            yield fork(processFeatureErrors, {
                data: {
                    orderItemId: action.data.data.orderItemId,
                    errorFeatureType: 'dtw',
                    errorValues: ex.response?.data,
                },
            });
        }
    }
}

function* workerSubmitDeliveryTime(action) {
    const cartId = yield select(getOrderId);
    try {
        const { data } = action;
        yield put(updateShowLoadingMessage());

        clearOrderItemErrors(
            data.orderItemId,
            'dtw',
            { errType: '', field: 'error' },
        );

        if (data) {
            const jwtToken = yield call(checkJWT);

            const payload = {
                env: {},
                jwtToken,
                cartId,
                cartItemId: data.orderItemId,
                dtwId: data.dtwId,
            };
            const response = yield call(cartServiceClient.updateDeliveryTime, payload);

            if (response.data.result === 'SUCCESS' && data.reason !== 'updateRecipient') {
                yield call(prepareRetreiveCart,  data.pageType);
                yield put(mfeGetCart());
            }
        }
        yield put(flagOffShowLoadingMessage());
    } catch (exp) {
        mbpLogger.logError({
            data: action.data,
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            function: 'workerSubmitDeliveryTime',
            jsError: exp,
            message: 'Submit DTW option failed',
        });
        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action.data.orderItemId,
                errorFeatureType: 'dtw',
                errorValues: exp.response?.data,
            },
        });
        yield put(flagOffShowLoadingMessage());
    }
}

function* onDTWSelect(action) {
    try {
        const options = yield select(getDTWOptions);
        const foundOption = options.find((option) => option.name === action.data);
        yield put(actions.updateSelectedDTW(foundOption));
    } catch (ex) {
        mbpLogger.logError({
            data: action.data,
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'onDTWSelect',
            jsError: ex,
            message: 'onDTWSelect',
        });
    }
}

function* watchGetDeliveryTime() {
    yield takeEvery(actions.getDTW().type, workerGetDeliveryTime);
}

function* watchSubmitDeliveryTime() {
    yield takeEvery(actions.submitDTW().type, workerSubmitDeliveryTime);
}

function* watchOnDTWSelect() {
    let action = yield take(actionTypes.SELECT_DTW);

    while (action !== END) {
        yield call(onDTWSelect, action);
        action = yield take(actionTypes.SELECT_DTW);
    }
}

const watchers = [
    fork(watchOnDTWSelect),
    fork(watchGetDeliveryTime),
    fork(watchSubmitDeliveryTime),
];

export { watchers, workerSubmitDeliveryTime };

export default {};
